import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, withKeys as _withKeys, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = { key: 4 }
const _hoisted_9 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_radio = _resolveComponent("q-radio")!

  return (_openBlock(), _createBlock(_component_q_radio, _mergeProps({
    class: [{ active: _ctx.companyKey === _ctx.model }, "iuf-radio"],
    val: _ctx.companyKey
  }, _ctx.RADIO_PROPS, {
    modelValue: _ctx.model,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model) = $event)),
    onClick: _ctx.selectCompany,
    onKeyup: _withKeys(_ctx.goNextStep, ["enter"])
  }), {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        (!_ctx.isNew)
          ? (_openBlock(), _createBlock(_component_q_icon, {
              key: 0,
              name: _ctx.ICONS_NAME.COMPANY_OUTLINE
            }, null, 8, ["name"]))
          : _createCommentVNode("", true),
        _createElementVNode("span", null, _toDisplayString(_ctx.company.name), 1),
        _createVNode(_component_q_tooltip, _normalizeProps(_guardReactiveProps(_ctx.TOOLTIP_PROPS)), {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.company.name), 1)
          ]),
          _: 1
        }, 16)
      ]),
      (_ctx.isNew)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("span", null, _toDisplayString(_ctx.t('NEW_COMPANY_HINT')), 1)
          ]))
        : (_ctx.isInBrief && _ctx.isCompanyAsset)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("span", null, _toDisplayString(_ctx.t('IN_THIS_BRIEF', { brief: _ctx.t('BRIEF.LOW.SING') })), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_ctx.isDirectoryCompany)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                    _createVNode(_component_q_icon, {
                      name: _ctx.ICONS_NAME.DATABASE_OUTLINE
                    }, null, 8, ["name"]),
                    _createElementVNode("span", null, _toDisplayString(_ctx.t('FROM_DIRECTORY', { database: _ctx.t('BRAND.DATA') })), 1)
                  ]))
                : (!_ctx.isNexusEntity(_ctx.company))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.t('NUMBER_OF_LEADS', { count: _ctx.leadCount, lead: _ctx.t('LEAD.LOW.SING'), leads: _ctx.t('LEAD.LOW.PLUR') }, _ctx.leadCount)), 1))
                  : _createCommentVNode("", true),
              (_ctx.company.address?.country?.label)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, " • " + _toDisplayString(_ctx.company.address.country.label), 1))
                : _createCommentVNode("", true),
              (_ctx.company.addresses?.[0]?.country?.label)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, " • " + _toDisplayString(_ctx.company.addresses[0].country.label), 1))
                : _createCommentVNode("", true),
              (_ctx.company.companyTypes && _ctx.company.companyTypes.length)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                    (!_ctx.isNexusEntity(_ctx.company))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, " • "))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(_ctx.companyTypeLabels), 1),
                    _createVNode(_component_q_tooltip, _normalizeProps(_guardReactiveProps(_ctx.TOOLTIP_PROPS)), {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.companyTypeLabels), 1)
                      ]),
                      _: 1
                    }, 16)
                  ]))
                : _createCommentVNode("", true)
            ]))
    ]),
    _: 1
  }, 16, ["class", "val", "modelValue", "onClick", "onKeyup"]))
}